import { createSlice } from '@reduxjs/toolkit';
import { get_All_Count} from './AllCountApi';

const AllCountApiSlice = createSlice({
  name: 'AllCountApi',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(get_All_Count.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(get_All_Count.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(get_All_Count.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});
export default AllCountApiSlice.reducer;
